export default "__VITE_ASSET__668d7a92__"